import clsx from "clsx"

export const labelStyles = error =>
  clsx(
    "block body font-bold pb-2",
    !error && "text-mineralGray",
    error && "text-red"
  )

export const textareaStyles = error =>
  clsx(
    "body pb-[13px] pt-3 border bg-white transition-colors duration-150 focus:outline-none rounded px-4 placeholder-gray placeholder-opacity-50 w-full shadow-none",
    !error && "border-gray focus:border-mineralGray text-mineralGray",
    error && "border-red text-red"
  )

export const errorStyles = "pt-1 text-red small-copy"
